module.exports = __webpack_public_path__ + "img/smile.21bf2079.svg";